import { render, staticRenderFns } from "./locked_badge.vue?vue&type=template&id=4f6f0b30"
import script from "./locked_badge.vue?vue&type=script&lang=js"
export * from "./locked_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports